<script lang="ts">
  import { Router } from 'svelte-routing';
  import App from './App.svelte';
</script>

<Router>
  <App />
</Router>
